import React from 'react';
import PropTypes from 'prop-types';
import SignupForm from 'src/modules/shared/modal/components/signup/signupForm';
import FacebookLoginButton from 'src/modules/shared/auth/components/facebookLoginButton';
import GoogleLoginButton from 'src/modules/shared/auth/components/googleLoginButton';
import { trackEvent } from 'src/utils/analytics';
import ModalAlert from 'src/modules/shared/modal/components/signup/modalAlert';
import { showLoginModal } from 'src/modules/shared/modal/actions';
import i18n from 'i18next';
import { connect } from 'react-redux';
import { truncate } from 'underscore.string';

class SignupBox extends React.Component {

  static propTypes = {
    group: PropTypes.object,
    title: PropTypes.string,
    subtitle: PropTypes.any,
    loginWithNoClose: PropTypes.bool,
    signupContext: PropTypes.object,
    visitorReply: PropTypes.object,
    defaultEmail: PropTypes.string,
    onSignupSuccess: PropTypes.func,
  }

  static defaultProps = {
    group: null,
    isSocial: true,
    mobileSubtitle: null,
    loginWithNoClose: false,
    defaultEmail: '',
    onSignupSuccess: () => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      showMobileEmailform: false,
    };
  }

  componentDidMount() {
    var group = this.props.group;
    var groupCode = group ? (group.groupCode || group.subDomain || group.slug) : 'N/A';
    trackEvent('Onboarding', 'Displayed popup', groupCode);
  }

  onClickLogin = (event) => {
    event.preventDefault();
    this.props.showLoginModal(this.props.loginWithNoClose, this.props.visitorReply, this.props.onSignupSuccess);
  }

  onClickSignUpWithEmail = () => {
    // Track in analytics
    const label = 'community post';//this.app.res.controller + ' ' + this.app.res.action; //TODO
    this.setState({
      showMobileEmailform: true,
    });
    trackEvent('Account', 'Clicked sign up with email', label);
  }

  onErrorSignup(status) {
    this.setState({
      alert: <ModalAlert>
        {status.message}
      </ModalAlert>,
    });
  }

  renderBrandStuff = () => {
    const title = this.props.title || i18n.t('Join HealthUnlocked');
    const { visitorReply } = this.props;
    return (
      <div className="signup-box__brand-message">
        <div className="signup-box__brand-message__content">
          <h1>{title}</h1>
          {!this.props.subtitle && (
            <div className="signup-box__brand-message__quote">
              “{i18n.t('HealthUnlocked changed my life, I am now more informed on how to better manage my condition, and know I am not alone.')}”
            </div>
          )}
          {!!this.props.subtitle && (
            <div className="signup-box__brand-message__features" >{this.props.subtitle}</div>
          )}
          {visitorReply && (
            <div className="signup-box__context-box">
              <div className="signup-box__context-box__title" >{i18n.t('Join to post your reply')}</div>
              <div className="signup-box__context-box__content">{`"${truncate(visitorReply.body, 15)}"`}</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSocialButtons = (showMobileEmailform) => {
    return <div className={showMobileEmailform ? 'hidden-xs signup-box__form__buttons' : 'signup-box__form__buttons'}>
      <FacebookLoginButton
        fullWidth={true}
        signupContext={this.props.signupContext}
        onSuccess={this.props.onSignupSuccess}
      />
      <GoogleLoginButton
        fullWidth={true}
        signupContext={this.props.signupContext}
        onSuccess={this.props.onSignupSuccess}
      />
    </div>;
  }

  render() {
    const { group, visitorReply } = this.props;
    const { showMobileEmailform } = this.state;
    const title = visitorReply && i18n.t('Join to post your reply')
      || this.props.title
      || i18n.t('Join HealthUnlocked');

    const mobileSubtitle = visitorReply && `"${truncate(visitorReply.body, 15)}"` || this.props.mobileSubtitle;

    return <section className="signup-box" >
      <h2 className="visible-xs modal-title signup-box__title">
        {title}
        {!!mobileSubtitle && (
          <div className="signup-box__mobile-subtitle" >
            {mobileSubtitle}
          </div>
        )}
      </h2>
      {this.state.alert}
      <div className="signup-box__context" >
        {this.renderBrandStuff()}
        <div className="signup-box__form">
          {this.renderSocialButtons(showMobileEmailform)}
          <div>
            <p className="signup-box__word-with-line">
              <span>{i18n.t('or')}</span>
            </p>
            <SignupForm
              buttonText={i18n.t('Join with email')}
              displayKeepLogged={false}
              groupCode={group.slug}
              initialValues={{ email: this.props.defaultEmail }}
              signupContext={this.props.signupContext}
              onSignupSuccess={this.props.onSignupSuccess}
            />
            <div className="signup-box__footer">
            <a href="#" onClick={this.onClickLogin}>{i18n.t('Already a member?')} {i18n.t('Log in')}</a>
            </div>
          </div>
        </div>
      </div>
    </section>;
  }
}

export default connect(null, { showLoginModal })(SignupBox);




// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup.js